<p class="title">{{ 'greeting' | translate: {name: name} }}</p>
<p>{{ 'codeSended' | translate }}</p>

<div id="mail-box-wrapper">
  <label>{{ 'email' | translate }}</label>
  <div id="mail-box">
    <mat-icon>forward_to_inbox</mat-icon>
    {{ email | hideStars }}
  </div>
</div>

<form [formGroup]="form" id="code-input" [ngClass]="{'error': error}">
  <input #firstInput formControlName="first" type="number" min="0" max="9" inputmode="numeric" pattern="[0-9]*" />
  <input #secondInput formControlName="second" type="number" min="0" max="9" inputmode="numeric" pattern="[0-9]*" />
  <input #thirdInput formControlName="third" type="number" min="0" max="9" inputmode="numeric" pattern="[0-9]*" />
  <input #forthInput formControlName="forth" type="number" min="0" max="9" inputmode="numeric" pattern="[0-9]*" />
</form>
<div id="otp-error" *ngIf="error"><mat-icon>info</mat-icon><div>{{ error_message }}</div></div>

<button class="btn btn-primary btn-w-100" (click)="submit()" [disabled]="loading || !form.valid">
  <ng-container *ngIf="!loading">
    {{ 'verifyCode' | translate }}
    <mat-icon>arrow_forward</mat-icon>
  </ng-container>
  <ng-container *ngIf="loading">
    <mat-progress-spinner color="white" mode="indeterminate" diameter="20"></mat-progress-spinner>
  </ng-container>
</button>

<button class="btn btn-primary btn-underline btn-w-100" *ngIf="retry_enabled" id="retryButton" (click)="retryRequestOtp()">{{ 'resendCode' | translate }}</button>
